export enum SalesHistoryColId {
  BILL_TO_ACCOUNT = 'billToAccount',
  CUSTOMER_PO_NUMBER = 'customerPoNumber',
  DOCUMENT_NUMBER = 'documentNumber',
  JOB_NAME = 'jobName',
  MARGIN = 'margin',
  ORDER_ID = 'orderId',
  QUANTITY = 'quantity',
  QUOTE_ID = 'quoteId',
  REQUEST_DATE = 'requestDate',
  SALES_LOCATION = 'salesLocation',
  SELL_PRICE = 'sellPrice',
  SHIP_FROM_LOCATION = 'shipFromLocation',
  SHIP_TYPE = 'shipType',
  STANDARD_COST = 'standardCost',
  UOM_CODE = 'uomCode',
}
